import { NextSeo } from "next-seo";

export const renderTheMetaTags = (metaData) =>
  metaData?.map((singleMeta) => {
    if (!singleMeta.name || !singleMeta.content) return;
    return (
      <NextSeo
        key={singleMeta?.id}
        title={singleMeta?.name}
        description={singleMeta?.content}
      />
    );
  });

export const isObjectNotEmpty = (obj) => {
  return obj && Object.keys(obj).length !== 0;
};
export const getFullDate = (date, locale) => {
  if (!date) return;

  const formattedLocale = locale === "ar" ? "ar-EG" : "en-US";

  return new Date(date).toLocaleDateString(formattedLocale, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const handleImageLink = (image) => {
  if (image?.includes("http")) {
    return image;
  } else {
    // eslint-disable-next-line no-undef
    return `${process.env.NEXT_PUBLIC_API_URL}/storage/uploads/${image}`;
  }
};
